import { render } from "./LecheFria.vue?vue&type=template&id=8fdeca28"
import script from "./LecheFria.vue?vue&type=script&lang=js"
export * from "./LecheFria.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/AccesoGanaderos/Calidad/LecheFria.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8fdeca28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8fdeca28', __exports__)) {
    api.reload('8fdeca28', __exports__)
  }
  
  module.hot.accept("./LecheFria.vue?vue&type=template&id=8fdeca28", () => {
    api.rerender('8fdeca28', render)
  })

}


export default __exports__